module.exports = __webpack_public_path__ + "static/media/AvenirNext-Bold.01db87c3.ttf";